import { Button, Card, Flex, Modal, Typography, Popconfirm } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import { push } from 'connected-react-router';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useInterval } from 'usehooks-ts';

import './index.css';

import Input from './-components/Input/Input';
import Message from './-components/Message/Message';
import AttachedFiles from './-components/AttachedFiles/AttachedFiles';
import { Layout_CenterWithSidebar } from '../../-components/layout/center-with-sidebar';
import { CONFIG } from '../../../../../constants/backendUrl';
import { getClientName, saveId } from '../../../../../Store/ApplicationsReducer/applicationsActions';

const saveToStorage = (key, data) => {
    try {
        if (data !== null && data !== undefined) {
            localStorage.setItem(key, JSON.stringify(data));
        }
    } catch (error) {
        console.error(`Ошибка при сохранении данных в localStorage (${key}):`, error);
    }
};

const loadFromStorage = (key, defaultValue = null) => {
    try {
        const savedData = localStorage.getItem(key);
        if (savedData) {
            return JSON.parse(savedData);
        }
    } catch (error) {
        console.error(`Ошибка при загрузке данных из localStorage (${key}):`, error);
    }
    return defaultValue;
};

const removeFromStorage = (...keys) => {
    try {
        keys.forEach(key => localStorage.removeItem(key));
    } catch (error) {
        console.error('Ошибка при удалении данных из localStorage:', error);
    }
};

export const Application_DeviceId_New_Chat = (props) => {
    const match = props.match || {};
    const { deviceId } = match.params || {};
    const { clientName } = useSelector(state => state.applications)
    const dispatch = useDispatch();

    const redirectTime = 3;
    const [messages, setMessages] = useState([]);
    const [isChatMode, setIsChatMode] = useState(false);
    const [threadId, setThreadId] = useState(null);
    const [needRedirectToTicket, setNeedRedirectToTicket] = useState(false);
    const [timerActive, setTimerActive] = useState(false);
    const [timerTick, setTimerTick] = useState(0);
    const [ticketHash, setTicketHash] = useState(null);
    const [messageAttachments, setMessageAttachments] = useState([]);
    const [sentFilesHistory, setSentFilesHistory] = useState([]);
    const messagesEndRef = useRef(null);

    const storageKey = `chat_messages_${deviceId}`;
    const filesStorageKey = `chat_files_${deviceId}`;
    const threadStorageKey = `chat_thread_${deviceId}`;

    const scrollToBottom = () => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
                inline: 'nearest'
            });
        }
    };

    const handleResetChat = () => {
        removeFromStorage(storageKey, filesStorageKey, threadStorageKey);
        setMessages([]);
        setIsChatMode(false);
        setThreadId(null);
        setMessageAttachments([]);
        setSentFilesHistory([]);
        dispatch(push(`/application/${deviceId}/new/chat`));
    };

    useEffect(() => {
        dispatch(getClientName(deviceId));
        dispatch(saveId(deviceId));

        const savedMessages = loadFromStorage(storageKey, []);
        const savedFiles = loadFromStorage(filesStorageKey, []);
        const savedThreadId = loadFromStorage(threadStorageKey, null);
        if (savedMessages.length > 0) {
            setMessages(savedMessages);
            setIsChatMode(true);
        }
        if (savedFiles.length > 0) {
            setSentFilesHistory(savedFiles);
        }
        if (savedThreadId) {
            setThreadId(savedThreadId);
        }

        return () => {
        };
    }, [dispatch, deviceId]);

    useEffect(() => {
        if (messages.length > 0) {
            saveToStorage(storageKey, messages);
        }
    }, [messages]);

    useEffect(() => {
        if (sentFilesHistory.length > 0) {
            saveToStorage(filesStorageKey, sentFilesHistory);
        }
    }, [sentFilesHistory]);

    useEffect(() => {
        if (threadId) {
            saveToStorage(threadStorageKey, threadId);
        }
    }, [threadId]);

    useEffect(() => {
        if (isChatMode && messages.length > 0) {
            const timeoutId = setTimeout(() => {
                scrollToBottom();
            }, 100);
            return () => clearTimeout(timeoutId);
        }
    }, [messages, isChatMode]);

    const gotoTask = (hash) => {
        dispatch(push(`/application/${deviceId}/${hash}`));
    }

    const handleFileChange = (fileList) => {
        setMessageAttachments(fileList);
    };

    const handleRemoveFile = (file) => {
        setMessageAttachments(prev => prev.filter(f => f.uid !== file.uid));
    };

    const handleSendMessage = async (text) => {
        let currentThreadId = threadId;

        if (!currentThreadId) {
            const response = await axios.post(`${CONFIG.aiIntegrationUrl}/new`, {
                deviceId
            });

            const threadPayload = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
            currentThreadId = threadPayload.threadId;
            setThreadId(currentThreadId);
        }

        const currentAttachments = [...messageAttachments];

        if (currentAttachments.length > 0) {
            setSentFilesHistory(prev => {
                return [...prev, ...currentAttachments];
            });
        } else {
            console.log('handleSendMessage no attachments to save');
        }

        const userMessage = {
            id: Date.now(),
            text,
            time: new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
            isUser: true,
            attachments: currentAttachments.length > 0 ? currentAttachments : undefined
        };

        const loadingMessage = {
            id: Date.now() + 1,
            text: '...',
            time: new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
            isUser: false,
            isLoading: true
        };

        setMessages(prev => [...prev, userMessage, loadingMessage]);
        setIsChatMode(true);

        setMessageAttachments([]);

        try {
            const formData = new FormData();

            formData.append('threadId', currentThreadId);
            formData.append('message', text);
            formData.append('deviceId', deviceId);

            const allFilesToSend = [...sentFilesHistory, ...currentAttachments];
            allFilesToSend.forEach(file => {
                const fileObj = file.originFileObj || file;
                if (fileObj) {
                    formData.append('files[]', fileObj);
                }
            });

            const response = await axios.post(`${CONFIG.aiIntegrationUrl}/process`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            const payload = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

            if (payload.ticket) {
                console.log('Setting ticket hash:', payload.ticket.eventID);
                removeFromStorage(storageKey, filesStorageKey, threadStorageKey);
                setTicketHash(payload.ticket.eventID);
                setNeedRedirectToTicket(true);
            }

            const botMessage = {
                id: Date.now() + 2,
                text: payload.response || 'Сообщение получено',
                time: new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
                isUser: false,
                isLoading: false,
                ticket: payload.ticket || null
            };
            setMessages(prev => prev.map(msg => (msg.isLoading ? botMessage : msg)));
        } catch (error) {
            const errorMessage = {
                id: Date.now() + 2,
                text: 'Извините, произошла ошибка при обработке вашего сообщения.',
                time: new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
                isUser: false
            };

            setMessages(prev => prev.map(msg => (msg.isLoading ? errorMessage : msg)));

            setMessageAttachments([]);
        }
    };

    useEffect(() => {
        if (needRedirectToTicket) {
            setTimerTick(0);
            setTimerActive(true);
            removeFromStorage(storageKey, filesStorageKey, threadStorageKey);
        } else {
            setTimerActive(false);
            setTimerTick(0);
        }
    }, [needRedirectToTicket]);

    useInterval(() => {
        if (timerActive) {
            setTimerTick(prev => {
                const nextTick = prev + 1;
                if (nextTick >= redirectTime) {
                    setTimerActive(false);
                    setNeedRedirectToTicket(false);
                    if (ticketHash) {
                        removeFromStorage(storageKey, filesStorageKey, threadStorageKey);
                        gotoTask(ticketHash);
                    }
                }
                return nextTick;
            });
        }
    }, timerActive ? 1000 : null);

    return (
        <Layout_CenterWithSidebar {...props}>
            <Flex vertical gap={24} className="application-chat">
                <Card className="application-chat__card" styles={{
                    body: { padding: '50px', height: '100%' }
                }}>
                    <Flex vertical className="application-chat__content">
                        {!isChatMode ? (
                            <>
                                <Flex justify="center" align="center" vertical className="application-chat__welcome">
                                    <Typography.Text className="application-chat__welcome-title">
                                        <b>{clientName?.name || 'Anonymous'}</b>, здравствуйте!
                                    </Typography.Text>
                                    <Typography.Text className="application-chat__welcome-subtitle">
                                        Опишите свою проблему.
                                    </Typography.Text>
                                    <AttachedFiles
                                        files={messageAttachments}
                                        onRemoveFile={handleRemoveFile}
                                        isChatMode={false}
                                    />
                                    <Flex vertical className="application-chat__input-container">
                                        <Input
                                            onSendMessage={handleSendMessage}
                                            attachments={messageAttachments}
                                            onFileChange={handleFileChange}
                                            isChatMode={false}
                                        />
                                    </Flex>
                                </Flex>
                            </>
                        ) : (
                            <>
                                <Modal centered open={needRedirectToTicket} footer={null} closable={false} onCancel={() => { }}>
                                    <Flex vertical align="center" gap={16} className="application-chat__redirect-modal-content">
                                        <Typography.Title level={4} className="application-chat__redirect-title">
                                            Переадресация на страницу заявки через
                                        </Typography.Title>
                                        <div className="application-chat__redirect-countdown" key={redirectTime - timerTick}>
                                            {Math.max(1, redirectTime - timerTick)}
                                        </div>
                                    </Flex>
                                </Modal>

                                <div className="ApplicationChat__messages">
                                    {messages.map(message => (
                                        <Message
                                            key={message.id}
                                            text={message.text}
                                            time={message.time}
                                            isUser={message.isUser}
                                            isLoading={message.isLoading}
                                            ticket={message.ticket}
                                            attachments={message.attachments}
                                        />
                                    ))}
                                    <div ref={messagesEndRef} />
                                </div>
                                <AttachedFiles
                                    files={messageAttachments}
                                    onRemoveFile={handleRemoveFile}
                                    isChatMode={true}
                                />
                                <Input
                                    onSendMessage={handleSendMessage}
                                    attachments={messageAttachments}
                                    onFileChange={handleFileChange}
                                    isChatMode={true}
                                />
                            </>
                        )}
                    </Flex>
                </Card>
                <Flex justify='center' gap={16} vertical align='center' className="application-chat__bottom-controls">
                    <Flex gap={16} className="application-chat__control-buttons">
                        <Button
                            type="primary"
                            onClick={() => {
                                removeFromStorage(storageKey, filesStorageKey, threadStorageKey);
                                dispatch(push(`/application/${deviceId}/new/ticket`));
                            }}
                        >Перейти в старую версию</Button>
                        {isChatMode && (
                            <Popconfirm
                                title="Начать новый чат?"
                                description="Текущая переписка будет удалена."
                                okText="Да"
                                cancelText="Отмена"
                                onConfirm={handleResetChat}
                                placement="top"
                            >
                                <Button
                                    type="default"
                                    icon={<PlusOutlined />}
                                    className="application-chat__new-chat-button"
                                >
                                    Новый чат
                                </Button>
                            </Popconfirm>
                        )}
                    </Flex>
                </Flex>
            </Flex>
        </Layout_CenterWithSidebar>
    )
}